module.exports = __webpack_public_path__ + "static/media/epuletbontas-rakoscsaba-ujtelep.b9f5c38a.jpg";